var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.52625 15.8539C6.55157 15.8771 6.57923 15.8979 6.60884 15.9161L6.65014 15.9361L6.70235 15.9621L6.75689 15.9782L6.80482 15.9904C6.87651 16.0043 6.95092 16.0043 7.023 15.9904L7.07092 15.9782L7.12547 15.9621L7.17767 15.9361L7.21897 15.9161C7.24897 15.8979 7.27664 15.8771 7.30196 15.8539L12.6977 10.9C12.8773 10.7014 12.8625 10.41 12.6634 10.2275C12.4643 10.045 12.1464 10.0314 11.9298 10.1961L7.45702 14.3V1.5C7.45702 1.22393 7.21274 1 6.91157 1C6.6104 1 6.36612 1.22393 6.36612 1.5V14.3L1.89339 10.1961C1.67677 10.0314 1.35884 10.045 1.15975 10.2275C0.960661 10.41 0.945856 10.7014 1.12547 10.9L6.52547 15.8539H6.52625Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.d1afa98ed2b84f67933e5636db2a113d.svg";
export { ForwardRef as ReactComponent };